"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _TrackingCodeEpic = _interopRequireDefault(require("./TrackingCodeEpic"));

var _settingsEpic = _interopRequireDefault(require("./settingsEpic"));

var _domainsEpic = _interopRequireDefault(require("./domainsEpic"));

var _subdomainsEpic = _interopRequireDefault(require("./subdomainsEpic"));

var _analyticsViewsEpic = _interopRequireDefault(require("./analyticsViewsEpic"));

var _saveStagedChangesEpic = _interopRequireDefault(require("./saveStagedChangesEpic"));

var _epics = _interopRequireDefault(require("settings-ui-sdk/UnifiedBranding/epics"));

var _default = (0, _reduxObservable.combineEpics)(_TrackingCodeEpic.default, _settingsEpic.default, _domainsEpic.default, _subdomainsEpic.default, _analyticsViewsEpic.default, _saveStagedChangesEpic.default, _epics.default);

exports.default = _default;
module.exports = exports.default;